import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7d179f5f&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=7d179f5f&prod&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=7d179f5f&prod&lang=css&"
import style2 from "./Footer.vue?vue&type=style&index=2&id=7d179f5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d179f5f",
  null
  
)

export default component.exports